<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import ManagePlaceTypesTable from '@/components/manage/place-type/ManagePlaceTypesTable.vue';
import { setTitle } from '@/utils/title';

const store = useStore();
const accountId = computed(() => store.getters['auth/accountId']);

setTitle('Geofence Types');
</script>

<template>
  <section class="max-w-[860px]">
    <ManagePlaceTypesTable v-if="accountId" :accountId="accountId" />
  </section>
</template>
